import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup.object({
  providerFields: yup.array().of(yup.string()),
  terminalType: yup.string(),

  interswitch_account_id: yup.string().when(["terminalType"], {
    is: (val) => val === "INTERSWITCH",
    then: (schema) => schema.required("Interswitch account is required"),
    otherwise: (schema) => schema.optional(),
  }),

  merchant_id: yup.string().when(["providerFields"], {
    is: (terminalFields) => terminalFields?.includes("merchant_id"),
    then: (schema) => schema.required("Merchant ID is required"),
    otherwise: (schema) => schema.optional(),
  }),

  terminal_id: yup.string().when(["providerFields"], {
    is: (terminalFields) => terminalFields?.includes("terminal_id"),
    then: (schema) => schema.required("Terminal ID is required"),
    otherwise: (schema) => schema.optional(),
  }),

  terminal_sn: yup.string().when(["providerFields"], {
    is: (terminalFields) => terminalFields?.includes("terminal_sn"),
    then: (schema) => schema.required("Serial number is required"),
    otherwise: (schema) => schema.optional(),
  }),

  account_number: yup.string().when(["providerFields"], {
    is: (terminalFields) => terminalFields?.includes("account_number"),
    then: (schema) => schema.required("Account number is required"),
    otherwise: (schema) => schema.optional(),
  }),

  account_name: yup.string().when(["providerFields"], {
    is: (terminalFields) => terminalFields?.includes("account_name"),
    then: (schema) => schema.required("Account name is required"),
    otherwise: (schema) => schema.optional(),
  }),
  store_id: yup.string().required("Store is required"),
});

const useValidation = ({ ...formDetails }) => {
  return useForm({
    resolver: yupResolver(schema),
    shouldFocusError: true,
    mode: "onBlur",
    defaultValues: {
      ...formDetails,
    },
  });
};

export default useValidation;
